import { SubscriptionPlan } from '../modal';
import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';

export default function reducer(state: SubscriptionPlan = new SubscriptionPlan(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SUBSCRIPTION_MGMT_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.SUBSCRIPTION_MGMT_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.SUBSCRIPTION_MGMT_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: true,
        data: payload,
      };
    default:
      return state;
  }
}
